import { Dayjs } from "dayjs";
import type { BaseEntity } from './BaseEntity';
import type { ConsumedInventoryItem } from './ConsumedInventoryItem';
import type { Customer } from './Customer';
import type { Product } from './Product';
import type { ProductItem } from './ProductItem';
import { Item } from './Item';
import { ProductInventoryItem } from './ProductInventoryItem';

export interface Batch extends BaseEntity {
  productId: number;
  product: Product;
  customerId?: number;
  customer: Customer;
  amount: number;
  lotNumber: string;
  isComplete: boolean;
  dateTimeCompleted: Dayjs;
  notes?: string | null;
  consumedInventoryItems: ConsumedInventoryItem[];
  calculatedProductItems?: ProductItem[];
  totalCost?: number;
  productInventoryItems?: ProductInventoryItem[];
}

export interface CombinedCalculatedItemResult {
  item: Item;
  totalQuantity: number;
  totalQuantityOnHand: number;
  totalRemainingQuantityOnHand: number;
}

export interface ProcessedBatchesResult {
  combinedCalculatedItemResults: CombinedCalculatedItemResult[];
  batches: Batch[];
  combinedMatchedBatch: Batch;
}

type ValidationResult = { issues: { message: string; path: (keyof Batch)[], index?: number }[] };

export function validate(product: Partial<Batch>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!product.amount) {
    issues = [...issues, { message: 'Amount is required', path: ['amount'] }];
  }

  return { issues };
}